<template>
  <NiceModal :name="name" :title="$gettext('Import partners')" @close="cancel" isForm @submit="submit">
    <section>
      <!-- File -->
      <NiceUpload :title="$gettext('File')" noMargin v-model="form.file" required></NiceUpload>

      <!-- Loading -->
      <NiceLoading v-if="loading" fullDiv></NiceLoading>

      <!-- Errors -->
      <NiceSlot v-if="error" class="mt-3" :title="$gettext('Errors')">
        <div class="error-box" v-for="(e, i) in error" :key="i">
          <b>{{ $gettext("Row") }}: {{ e.row }}</b>
          <div>{{ e.error }}</div>
        </div>
      </NiceSlot>

      <!-- <pre>{{ form }}</pre> -->
    </section>

    <template #footer>
      <!-- Cancel -->
      <NiceButton :text="$gettext('Cancel')" :loading="loading" @click="cancel" type="default" plain icon="icon-x" />

      <!-- Submit -->
      <NiceButton :text="$gettext('Submit')" :loading="loading" nativeType="submit" icon="icon-check" />
    </template>
  </NiceModal>
</template>

<script setup>
import ApiService from "@/services/api/api.service";
import CommonService from "@/services/common.service";
import ErrorService from "@/services/error.service";

import { defineEmits, inject, ref } from "vue";
const nice = inject("nice");

import { useRouter } from "vue-router";
const router = useRouter();

import { useGettext } from "vue3-gettext";
const { $gettext } = useGettext();

const emit = defineEmits(["cancel", "success"]);

const name = "import-partners";
const loading = ref(false);
const error = ref(null);
const form = ref({
  file: null,
});
const organizationId = router.currentRoute.value.params.organizationId;
const eventId = router.currentRoute.value.params.eventId;

function close() {
  error.value = null;
  form.value.file = null;
  nice.modal(name, false);
}

function cancel() {
  emit("cancel");
  close();
}

async function submit() {
  error.value = null;
  loading.value = true;
  try {
    await ApiService.partners.import(organizationId, eventId, form.value.file[0]);
    CommonService.success($gettext("Successfully imported partners."));
    emit("success");
    close();
  } catch (e) {
    ErrorService.showError(e);
    if (e.message && e.message.rows_with_errors) error.value = e.message.rows_with_errors;
  } finally {
    loading.value = false;
  }
}
</script>
